import { useSelector } from "react-redux";
import { forwardRef, useImperativeHandle } from "react";
import Strings from "../../../../resources/Strings";
import classes from "./MessagingContentCard.module.css";
import Icons from "../../../../resources/icons/Icons";
import { Divider } from "@mui/material";
import store from "../../../../redux/Store";
import { commonActions } from "../../../../redux/reducers/CommonReducer";

import { TableModalEntity } from "../../../../entities/UIEntities/TableModalEntity";
import { RECIPIENTS_HISTORY_TABLE_COLUMNS, INVALID_RECIPIENTS_TABLE_COLUMNS, RECIPIENTS_TABLE_COLUMNS } from "../../../../constants/Constants";
import { CAMPAIGN_TYPES, SEND_STATUSES, TABLES } from "../../../../enums/Enums";
import { getMessagingHistoryUsers, getRecipientsParkersData, getUsersByRecipients } from "../../../../utils/MessagingUtils";

const MessagingRecipientsContentCard = forwardRef((props, ref) => {
  const currentScopeUsers = useSelector((state) => state.messaging.currentScopeUsers);
  const currentGmtUsers = useSelector((state) => state.user.currentGmtUsers);
  const currentUsers = currentScopeUsers.concat(currentGmtUsers);
  const mailingLists = useSelector((state) => state.messaging.mailingListsData?.mailingLists);
  
  // opened from messagingHistory / opened from campaign 
  const isOpenedFromMessagingHistory = props?.tableName === Strings.TABS_NAMES.MESSAGING_HISTORY;
  const usersFromRecipients = isOpenedFromMessagingHistory ? getMessagingHistoryUsers(currentUsers, props) : getUsersByRecipients({recipients: props?.recipients, mailingLists, currentUsers});
  const allRecipients = getRecipientsParkersData(usersFromRecipients);
  const validRecipients = isOpenedFromMessagingHistory ? allRecipients?.filter(r => r.subscriptionStatus === SEND_STATUSES.DELIVERED) : allRecipients?.filter(recipient => recipient.subscriptionStatus === Strings.SUBSCRIBED && (recipient.reason === "" || (recipient.reason !== "" && (props.campaignType.value === CAMPAIGN_TYPES.MAIL && recipient.email !== Strings.NOT_AVAILABLE || props.campaignType.value === CAMPAIGN_TYPES.MOBILE && recipient.phoneNumber !== Strings.NOT_AVAILABLE))));
  const invalidRecipients = isOpenedFromMessagingHistory ? allRecipients?.filter(r => r.subscriptionStatus !== SEND_STATUSES.DELIVERED) : allRecipients?.filter(recipient => recipient.subscriptionStatus !== Strings.SUBSCRIBED || (recipient.reason !== "" && (props.campaignType.value === CAMPAIGN_TYPES.MAIL && recipient.email === Strings.NOT_AVAILABLE || props.campaignType.value === CAMPAIGN_TYPES.MOBILE && recipient.phoneNumber === Strings.NOT_AVAILABLE)));

  useImperativeHandle(ref, () => ({
    validRecipients
  }));

  const openValidRecipientsTableModal = () => {
    const validRecipientsTableModal = new TableModalEntity(
      `${Strings.VALID_RECIPIENTS} (${validRecipients?.length})`,
      isOpenedFromMessagingHistory ? RECIPIENTS_HISTORY_TABLE_COLUMNS : RECIPIENTS_TABLE_COLUMNS,
      validRecipients, 
      TABLES.MODAL_TABLE 
    );

    store.dispatch(commonActions.setTableModal(validRecipientsTableModal));
  };

  const openInvalidRecipientsTableModal = () => {
    const invalidRecipientsTableModal = new TableModalEntity(
      `${Strings.INVALID_RECIPIENTS} (${invalidRecipients?.length})`,
      isOpenedFromMessagingHistory ? RECIPIENTS_HISTORY_TABLE_COLUMNS : INVALID_RECIPIENTS_TABLE_COLUMNS,
      invalidRecipients, 
      TABLES.MODAL_TABLE 
    );

    store.dispatch(commonActions.setTableModal(invalidRecipientsTableModal));
  };

  return (
    <div className={classes.contentCardContainer}>
      <Divider />
      <div className={classes.messagingContainer}>
        <div className={classes.messagingItem}>
          <div className={[classes.total, classes.open].join(' ')} onClick={openValidRecipientsTableModal}><img src={Icons.EXTERNAL} />{Strings.VIEW_VALID_RECIPIENTS} ({validRecipients?.length})</div>
        </div>
      </div>
      <Divider />
      <div className={classes.messagingContainer}>
        <div className={classes.messagingItem}>
          <div className={[classes.total, classes.open].join(' ')} onClick={openInvalidRecipientsTableModal}><img src={Icons.EXTERNAL} />{Strings.VIEW_INVALID_RECIPIENTS} ({invalidRecipients?.length})</div>
        </div>
      </div>
    </div>
  );
}); // added ) - for forward ref

export default MessagingRecipientsContentCard;
